import { render, staticRenderFns } from "./FloorRoomItem.vue?vue&type=template&id=8075ac1a&scoped=true"
import script from "./FloorRoomItem.vue?vue&type=script&lang=js"
export * from "./FloorRoomItem.vue?vue&type=script&lang=js"
import style0 from "./FloorRoomItem.vue?vue&type=style&index=0&id=8075ac1a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8075ac1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8075ac1a')) {
      api.createRecord('8075ac1a', component.options)
    } else {
      api.reload('8075ac1a', component.options)
    }
    module.hot.accept("./FloorRoomItem.vue?vue&type=template&id=8075ac1a&scoped=true", function () {
      api.rerender('8075ac1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/FloorRoomItem.vue"
export default component.exports